// TaskFlow · cambios en vivo. Conecta al servicio «vivo» y avisa a la vista abierta.
import { estado } from './api.js';
import { anunciar } from './util.js';

let ws = null;
let intentos = 0;
let latido = null;
const oyentes = new Set();
export function alEvento(f) { oyentes.add(f); return () => oyentes.delete(f); }

export function conectarEventos() {
  if (!estado.fichaEventos || (ws && ws.readyState <= 1)) return;
  const url = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/vivo/eventos?t=${encodeURIComponent(estado.fichaEventos)}`;
  ws = new WebSocket(url);
  ws.onopen = () => { intentos = 0; clearInterval(latido); latido = setInterval(() => { try { ws.send('.'); } catch { /* */ } }, 25000); };
  ws.onmessage = (m) => {
    let ev; try { ev = JSON.parse(m.data); } catch { return; }
    if (ev.tipo === 'hola') return;
    // Los cambios propios ya se ven en pantalla: no se anuncian.
    if (ev.texto && ev.por !== estado.usuario?.id) anunciar(ev.texto);
    oyentes.forEach((f) => { try { f(ev); } catch (err) { console.error(err); } });
  };
  ws.onclose = () => {
    clearInterval(latido);
    ws = null;
    if (!estado.usuario) return;
    const espera = Math.min(30000, 1000 * 2 ** intentos++);
    setTimeout(conectarEventos, espera);
  };
}
export function desconectarEventos() { if (ws) { const w = ws; ws = null; w.onclose = null; w.close(); } }
